/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { GetFeeConfigsStatus200, GetFeeConfigsStatus500 } from '../types/GetFeeConfigs'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getFeeConfigs } from '../clients/getFeeConfigs'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getFeeConfigsQueryKey = () => [{ url: '/v1/fees/config' }] as const

type GetFeeConfigsQueryKey = ReturnType<typeof getFeeConfigsQueryKey>

export function getFeeConfigsQueryOptions(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getFeeConfigsQueryKey()
  return queryOptions<
    GetFeeConfigsStatus200,
    ResponseErrorConfig<GetFeeConfigsStatus500>,
    GetFeeConfigsStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getFeeConfigs({
        ...config,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @description Admin only. Returns the configured trading fee rate for each fee tier. The rate is applied to the traded USD notional of a user's fills when the daily settlement run bills them.
 * @summary Get the trading fee configuration of every tenant and tier.
 * {@link /v1/fees/config}
 */
export function useGetFeeConfigs<
  TData = GetFeeConfigsStatus200,
  TQueryData = GetFeeConfigsStatus200,
  TQueryKey extends QueryKey = GetFeeConfigsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetFeeConfigsStatus200,
        ResponseErrorConfig<GetFeeConfigsStatus500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getFeeConfigsQueryKey()

  const queryResult = useQuery(
    {
      ...getFeeConfigsQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetFeeConfigsStatus500>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
